import {EMPTY_ROUTINE_DETAIL_PARAMS, EMPTY_TOKEN_FILTER_PARAMS} from 'src/app/projects/shared/projects-constants';
import {
  ChallengeView,
  Project,
  ProjectView,
  ProjectViewRepeatingTaskHistoryDetailParams,
  ProjectViewRoutineDetail,
  RepeatingTaskHistoryItem,
} from '../../model/project';
import {TaskTemplate} from '../../model/task';

export interface ProjectsState {
  projects: Project[];
  projectsSummary: Partial<Project>[];
  projectsMap: Record<string, Project>;
  projectViews: Record<string, ProjectView>;
  projectChallenges: Record<string, Project>;
  projectChallengeMap: Record<string, ChallengeView>;
  projectViewTaskId: string;
  routineDetailMap: Record<string, ProjectViewRoutineDetail>;
  taskTemplates: TaskTemplate[];
  projectViewRoutineDetailParams: ProjectViewRepeatingTaskHistoryDetailParams;
  projectViewTokenFilterParams: Record<string, string>;
  twsSubtaskView: string;
  repeatingTaskHistoryMap: Record<string, RepeatingTaskHistoryItem>;
  projectViewScrollPosition: number;
  currentProjectsRoute: string | null;
}

export const initialProjectsState: ProjectsState = {
  projects: null,
  projectsSummary: null,
  projectsMap: {},
  projectViews: {},
  projectChallenges: {},
  projectChallengeMap: {},
  projectViewTaskId: null,
  routineDetailMap: {},
  taskTemplates: null,
  projectViewRoutineDetailParams: EMPTY_ROUTINE_DETAIL_PARAMS,
  projectViewTokenFilterParams: EMPTY_TOKEN_FILTER_PARAMS,
  twsSubtaskView: 'subtask',
  repeatingTaskHistoryMap: {},
  projectViewScrollPosition: 0,
  currentProjectsRoute: null,
};
